import React from 'react'
import { selectCurrentUser } from "@/store/slices/authSlice";
import { useSelector } from "react-redux";
import Chip from '@mui/material/Chip';
const UserRFC = (): any => {

  // current user logged
  const user: any = useSelector(selectCurrentUser);

  //const avatarIcon = 'https://assets.stickpng.com/images/58428cc1a6515b1e0ad75ab1.png';

  return (
    <>
      <Chip
        //avatar={<img src={avatarIcon} height={20} />}
        label={<p>{user?.rfc || 'RFCEMPRESA'}</p>}
        variant="outlined"
        size="medium"
        sx={
          {
            p: 1,
            border: 'none',
            fontWeight: 'bold',
          }
        }
      />
    </>
  )
}

export default UserRFC